import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface OnlineUser {
  medewerker_id: string;
  username: string;
  avatar_url: string | null;
}

export const useOnlineUsers = () => {
  return useQuery<OnlineUser[]>({
    queryKey: ["online-users"],
    queryFn: async () => {
      // Get active, non-expired sessions
      const { data: sessions, error: sessError } = await supabase
        .from("auth_sessions")
        .select("medewerker_id")
        .eq("is_active", true)
        .gt("expires_at", new Date().toISOString());

      if (sessError || !sessions?.length) return [];

      // Deduplicate medewerker_ids
      const uniqueIds = [...new Set(sessions.map((s) => s.medewerker_id).filter(Boolean))] as string[];
      if (uniqueIds.length === 0) return [];

      const { data: users, error: usersError } = await supabase
        .from("medewerkers")
        .select("id, username, avatar_url")
        .in("id", uniqueIds)
        .eq("active", true);

      if (usersError || !users) return [];

      return users.map((u) => ({
        medewerker_id: u.id,
        username: u.username || "Onbekend",
        avatar_url: u.avatar_url,
      }));
    },
    refetchInterval: 30000,
    staleTime: 15000,
  });
};
